import { useEffect, useRef, useState } from 'react';
import '../App.css';
const NotifModal = ({ isOpen, onClose, children, anchorEl }) => {
  const modalRef = useRef(null);
  const [position, setPosition] = useState({});
  const [shouldRender, setShouldRender] = useState(false);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      const timer = setTimeout(() => setIsActive(true), 10);
      return () => clearTimeout(timer);
    } else {
      setIsActive(false);
      const timer = setTimeout(() => setShouldRender(false), 200);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  useEffect(() => {
    if (shouldRender && anchorEl && modalRef.current) {
      const anchorRect = anchorEl.getBoundingClientRect();
      const modalWidth = modalRef.current.offsetWidth;
      const top = anchorRect.bottom + window.scrollY + 10;
      let left = anchorRect.right + window.scrollX - modalWidth;
      if (left < 0) {
        left = anchorRect.left + window.scrollX;
      }
      setPosition({ top, left });
    }
  }, [shouldRender, anchorEl, children]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        anchorEl &&
        !anchorEl.contains(event.target)
      ) {
        onClose();
      }
    };
    if (shouldRender) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [shouldRender, onClose, anchorEl]);
  if (!shouldRender) return null;
  return (
    <div
      ref={modalRef}
      className={`notification-modal-content ${isActive ? 'active' : ''}`}
      style={{
        ...position,
      }}
    >
      {children}
    </div>
  );
};
export default NotifModal;
